(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ewocar-welcome"]) return;
  try {
    
  if (!customElements.get('ewocar-welcome')) {
    class EwocarWelcome extends HTMLElement {
      static shownKeys = new Set();

      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.codeField = this.querySelector('[data-welcome-code]');
        this.copyButton = this.querySelector('[data-welcome-copy]');
        this.status = this.querySelector('[data-welcome-status]');
        this.code = this.dataset.code?.trim();
        this.preview = this.dataset.designMode === 'true' && this.dataset.editorPreview === 'true';
        if (!this.code || !this.dialog?.showModal || (this.dataset.designMode === 'true' && !this.preview)) return;

        this.storageKey = `ewocar:welcome:1:${encodeURIComponent(this.code.toUpperCase())}`;
        this.retryCount = 0;
        this.readyAt = Date.now() + (this.preview ? 1000 : Math.max(3, Number(this.dataset.delay) || 8) * 1000);
        const options = { signal: this.abortController.signal };

        this.querySelectorAll('[data-welcome-close]').forEach(button => {
          button.addEventListener('click', () => this.dialog.close(), options);
        });
        this.dialog.addEventListener('close', () => this.afterClose(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            this.dialog.close();
          }
        }, options);
        this.copyButton.addEventListener('click', () => this.copyCode(), options);
        this.querySelector('[data-welcome-open]').addEventListener('click', () => this.openOffer(), options);
        this.codeField.addEventListener('click', () => this.codeField.select(), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        document.addEventListener('focusout', () => this.schedule(), options);
        document.addEventListener('visitorConsentCollected', () => this.schedule(), options);
        this.schedule(Math.max(0, this.readyAt - Date.now()));
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.abortController?.abort();
        document.documentElement.classList.remove('ewocar-welcome-open');
      }

      hasShown() {
        if (this.preview) return false;
        if (EwocarWelcome.shownKeys.has(this.storageKey)) return true;
        for (const name of ['localStorage', 'sessionStorage']) {
          try {
            if (window[name].getItem(this.storageKey) === '1') return true;
          } catch {}
        }
        return false;
      }

      rememberShown() {
        if (this.preview) return;
        EwocarWelcome.shownKeys.add(this.storageKey);
        for (const name of ['localStorage', 'sessionStorage']) {
          try {
            window[name].setItem(this.storageKey, '1');
            return;
          } catch {}
        }
      }

      schedule(delay = 1500) {
        window.clearTimeout(this.timer);
        if (!this.isConnected || this.dialog?.open || this.finished || this.hasShown()) return;
        this.timer = window.setTimeout(() => this.tryOpen(), delay);
      }

      isBlocked() {
        if (document.visibilityState !== 'visible') return true;
        const active = document.activeElement;
        if (active?.matches('input, textarea, select, [contenteditable=""], [contenteditable="true"]') || active?.closest('form')) return true;
        return [...document.querySelectorAll('dialog[open], [aria-modal="true"], [role="alertdialog"], #shopify-pc__banner')].some(element => {
          if (element === this.dialog || element.closest('[hidden], [aria-hidden="true"], [inert], details:not([open])')) return false;
          const style = window.getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
        });
      }

      tryOpen() {
        if (!this.isConnected || this.finished || this.dialog.open || this.hasShown()) return;
        if (Date.now() < this.readyAt) {
          this.schedule(this.readyAt - Date.now());
          return;
        }
        if (this.isBlocked()) {
          this.retryCount += 1;
          if (this.retryCount < 120) this.schedule();
          return;
        }
        this.openOffer();
      }

      openOffer() {
        if (!this.isConnected || this.dialog.open || this.isBlocked()) return;
        window.clearTimeout(this.timer);
        this.previousFocus = document.activeElement;
        try {
          this.dialog.showModal();
          this.rememberShown();
          this.finished = true;
          document.documentElement.classList.add('ewocar-welcome-open');
        } catch {
          this.finished = true;
        }
      }

      afterClose() {
        document.documentElement.classList.remove('ewocar-welcome-open');
        if (this.previousFocus?.isConnected && this.previousFocus !== document.body) {
          this.previousFocus.focus({ preventScroll: true });
        }
      }

      async copyCode() {
        const controller = this.abortController;
        this.copyButton.disabled = true;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(this.code);
          if (controller.signal.aborted) return;
          this.copyButton.textContent = this.dataset.copiedLabel;
          this.status.textContent = this.dataset.copySuccess;
        } catch {
          if (controller.signal.aborted) return;
          this.codeField.focus({ preventScroll: true });
          this.codeField.select();
          this.status.textContent = this.dataset.copyFallback;
        } finally {
          if (!controller.signal.aborted) this.copyButton.disabled = false;
        }
      }
    }
    customElements.define('ewocar-welcome', EwocarWelcome);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
